import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink } from '@fortawesome/free-solid-svg-icons';

const MyWorkDetail = ({work}) => {
    return (
      <div className="row g-0 p-5">
          <div className="col-md-7">
          <img className="img-fluid rounded-1 mb-3 me-3" src={work.workPhoto} alt="work" />
          <p className="card-text text-dark"><strong class="text-dark">Used Technologies: </strong><small>{work. technology}</small></p>
      </div>
      <div className="col-md-5">
      <div className="card-body">
        <h3 className="card-title text-dark">{work.projectName}</h3>
        <p className="card-text text-dark fs-5">{work.description}</p>
        <a href={work.link} className="btn btn-warning fw-bold me-2 mb-2" target="_blank"><FontAwesomeIcon icon={faLink} /> Live Preview</a><span>
        <a className="btn btn-warning fw-bold mb-2" href={work.source} target="_blank"><FontAwesomeIcon icon={faLink} /> Code</a>
        </span>
      </div>
    </div>
      </div>
    );
};

export default MyWorkDetail;